export default "__VITE_ASSET__89wwvSvp__"